import React from 'react';

import initReactApp from 'dpl/util/initReactApp';
import GlobalMobileMenuNavigationButtonContainer from 'dpl/containers/GlobalMobileMenu/GlobalMobileMenuNavigationButtonContainer';
import MobileNavigationMenuContainer from 'dpl/join_as_breeder/containers/MobileNavigationMenuContainer';
import PuppyCollegeQuoteCarouselContainer from 'dpl/puppy_college/containers/PuppyCollegeQuoteCarouselContainer';
import TrustSection from 'dpl/common/components/TrustSection';
import PuppyCollegeGetStartedLink from 'dpl/puppy_college/components/PuppyCollegeGetStartedLink';

initReactApp({
  MobileNavigationMenuContainer,
  /* eslint-disable react/display-name */
  MobileNavigationMenuButton: () => (
    <GlobalMobileMenuNavigationButtonContainer />
  ),
  BreederApplicationContainer: () => (
    <PuppyCollegeGetStartedLink
      variant="white"
      className="dib f4-xl pv5 ph8 ph12-xl bw0"
    />
  ),
  PuppyCollegeNavigationApplicationContainer: () => (
    <PuppyCollegeGetStartedLink className="w-100 w-auto-ns pv3" />
  ),
  PuppyCollegeQuoteCarouselContainer,
  /* eslint-enable react/display-name */
  TrustSection
});
